<template>
  <div class="mop-datatable">
    <div class="table-header">
      <div class="flex justify-between align-items-center">
        <div class="flex align-items-center">
          <MOPButton   v-if="clearShow"  label="Clear" icon="pi pi-filter-slash" iconPos="right" @click="clearFilter"/>
        </div>
       <div class="flex">

        <!-- <MOPButton v-if="importshow" label="Excel Import" class="me-3" icon="pi pi-file-excel" iconPos="right" @click="triggerFileInput"/> -->

        <MOPButton v-if="bulkimport" label="Bulk Import" class="me-3" icon="pi pi-file-excel" iconPos="right" @click="triggerFileInput"/>


        <!-- <MOPButton label=" Excel Import" class="me-3" icon="pi pi-file-excel" iconPos="right" @click="triggerFileInput"/> -->

  <input type="file" ref="fileInput" @change="handleFileUpload" accept=".xlsx, .xls" style="display: none" />
  <slot name="table-actions1"></slot>
        <MOPInputIcon
          icon="pi pi-search"
          v-model="globalFilterValue"
          placeholder="Search..."
          @input="onGlobalFilter"
        />

        <!-- Slot for additional buttons/menus -->
        <slot name="table-actions"></slot>

        <MOPButton v-if="exportStatus==0"  class="ms-3" icon="pi pi-download" severity="secondary" @click="toggle" />
        <MOPMenu ref="menu" id="overlay_menu" :model="items" :popup="true" />
       </div>
      </div>
    </div>
<!-- {{ props.value }} -->
    <DataTable
      ref="dataTableRef"
      v-bind="$attrs"
      :value="props.value"
      :dataKey="props.dataKey"
      :rows="shouldShowPagination ? props.rows : totalDataCount"
      :totalRecords="props.totalRecords"
      :paginator="shouldShowPagination"
      :paginatorPosition="props.paginatorPosition"
      :pageSizeOptions="props.pageSizeOptions"
      :selectionMode="props.selectionMode"
      :selection="props.selection"
      :sortable="props.sortable"
      :sortField="props.sortField"
      :sortOrder="props.sortOrder"
      :multiSort="props.multiSort"
      v-model:filters="filters"
      :loading="props.loading"
      :rowHover="props.rowHover"
      :showGridlines="props.showGridlines"
      :stripedRows="props.stripedRows"
      :scrollable="props.scrollable"
      :resizable="props.resizable"
      :resizableColumns="!!props.resizableColumns"
      :class="tableClasses"
      filterDisplay="menu"
      @selection-change="onSelectionChange"
      @page="onPage"
      @sort="onSort"
      @filter="onFilter"
      @row-click="onRowClick"
      @row-dblclick="onRowDblClick"
    >
      <!-- Dynamic Columns -->
      <Column v-for="col in props.columns"
             :key="col.field"
             :field="col.field"
             :header="col.header"
             :sortable="col.sortable"
             :filterable="col.filterable"
             :alignFrozen="col.alignFrozen"
             :frozen ="col.frozen"
             :bodyClass="col.bodyClass"
             :hidden="col.hidden">
        <template #filter="{ filterModel }">
          <InputText
            v-model="filterModel.value"
            class="p-column-filter-element"
            :placeholder="`Search by ${col.header.toLowerCase()}`"
            @input="applyColumnFilter(col.field)"
          />
        </template>

        <template #body="slotProps">
          <slot :name="'body-' + col.field" v-bind="slotProps">
            {{ slotProps.data[col.field] }}
          </slot>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script setup lang="ts">
import { ref, computed ,onMounted} from 'vue'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import { FilterMatchMode, FilterOperator } from '@primevue/core/api'
import type { DataTableFilterMeta, DataTablePageEvent, DataTableSortEvent } from 'primevue/datatable'
import type { MOPDataTableProps, MOPDataTableFilterEvent } from './types'

defineOptions({
  name: 'MOPDataTable',
  inheritAttrs: false
})

const props = withDefaults(defineProps<MOPDataTableProps>(), {
  rows: 10,
  first: 0,
  totalRecords: 0,
  transactionStatus: 0,
clearShow:true,
  paginator: false,
  paginatorPosition: 'bottom',
  pageSizeOptions: () => [10, 20, 30, 50],
  selectionMode: undefined,
  selection: undefined,
  sortable: false,
  sortField: undefined,
  sortOrder: undefined,
  multiSort: false,
  filterable: false,
  alignFrozen:'',
  frozen:false,
  bodyClass:'',
  loading: false,
  rowHover: false,
  showGridlines: false,
  stripedRows: false,
  size: 'normal',
  scrollable: false,
  resizable: false,
  resizableColumns: undefined,
  rtl: false,
  responsive: false,
  ariaLabel: 'Data Table',
  paginatorAriaLabel: 'Pagination',
  filterDisplay: undefined,
  globalFilterFields: () => [],
  showFilterMatchModes: true,
  filterMenuStyle: undefined,
  importStatus:0,
  exportStatus:0,
  importshow:false,
  bulkimport:true

})

const emit = defineEmits([
  'update:selection',
  'selection-change',
  'update:first',
  'page',
  'update:sortField',
  'update:sortOrder',
  'sort',
  'update:filters',
  'filter',
  'row-click',
  'row-dblclick',
  'excel-data-import',
  'importclick'
])

const dataTableRef = ref()
const globalFilterValue = ref('')

interface FilterMetaData {
  value: any
  matchMode: string
}
const fileInput: any = ref(null);

const triggerFileInput = () => {
if(props.importStatus==0){
emit('importclick')
}else{
  if (fileInput.value) {
    fileInput.value.click();
  }
}

};

const filters = ref<DataTableFilterMeta>({
  global: { value: null, matchMode: FilterMatchMode.CONTAINS } as FilterMetaData,
  ...props.columns.reduce((acc, col) => ({
    ...acc,
    [col.field]: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }]
    }
  }), {} as DataTableFilterMeta)
})

const clearFilter = () => {
  filters.value = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS } as FilterMetaData,
    ...props.columns.reduce((acc, col) => ({
      ...acc,
      [col.field]: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }]
      }
    }), {} as DataTableFilterMeta)
  }
  globalFilterValue.value = ''
  emit('update:filters', filters.value)
}

const onGlobalFilter = () => {
  const globalFilter = filters.value.global as FilterMetaData
  globalFilter.value = globalFilterValue.value
  emit('update:filters', filters.value)
}

const clearColumnFilter = (field: string) => {
  if (filters.value[field]) {
    filters.value[field] = {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }]
    }
    emit('update:filters', filters.value)
  }
}

const applyColumnFilter = (field: string) => {
  emit('update:filters', filters.value)
  emit('filter', {
    filters: filters.value,
    field
  })
}

const onSelectionChange = (event: { value: any }) => {
  emit('update:selection', event.value)
  emit('selection-change', event.value)
}

const onPage = (event: DataTablePageEvent) => {
  emit('update:first', event.first)
  emit('page', {
    page: Math.floor(event.first / props.rows!),
    first: event.first,
    rows: event.rows,
    pageCount: Math.ceil(props.totalRecords! / event.rows)
  })
}

const onSort = (event: DataTableSortEvent) => {
  const { sortField, sortOrder } = event
  emit('update:sortField', sortField)
  emit('update:sortOrder', sortOrder)
  emit('sort', { sortField, sortOrder })
}

const onFilter = (event: MOPDataTableFilterEvent) => {
  emit('update:filters', event.filters)
  emit('filter', event)
}

const onRowClick = (event: { originalEvent: Event; data: Record<string, unknown>; index: number }) => {
  emit('row-click', event)
}

const onRowDblClick = (event: { originalEvent: Event; data: Record<string, unknown>; index: number }) => {
  emit('row-dblclick', event)
}
const handleFileUpload = async (event: Event) => {
      const input = event.target as HTMLInputElement;
      const file = input.files ? input.files[0] : null;
      if (file) {
        try {
          // Read the Excel file
          const reader = new FileReader();
          reader.onload = async (e) => {
            try {
              const data = e.target?.result;
              // Import xlsx dynamically
              const XLSX = await import('xlsx');

              // Parse the Excel data
              const workbook = XLSX.read(data, { type: 'array' });
              const firstSheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[firstSheetName];

              // Convert to JSON
              const jsonData = XLSX.utils.sheet_to_json(worksheet);

              console.log("Excel data parsed successfully", jsonData);

              // Emit the parsed data to the parent component
              emit("excel-data-import", jsonData);

              // Reset the file input
              if (fileInput.value) {
                fileInput.value.value = '';
              }
            } catch (error) {
              console.error("Error parsing Excel file", error);
            }
          };
          reader.readAsArrayBuffer(file);
        } catch (error) {
          console.error("Error uploading file", error);
        }
      }
    };
// Computed property to determine if pagination should be shown
const shouldShowPagination = computed(() => {
  if (!props.paginator) return false
  const dataLength = props.value?.length || 0
  return dataLength > (props.rows || 10)
})

// Computed property to get total data count for non-paginated view
const totalDataCount = computed(() => {
  return props.value?.length || 0
})

const tableClasses = computed(() => [
  'p-datatable p-component',
  {
    'p-datatable-hoverable-rows': props.rowHover,
    'p-datatable-auto-layout': !props.scrollable,
    'p-datatable-resizable': props.resizable,
    'p-datatable-resizable-fit': props.resizableColumns === 'fit',
    'p-datatable-striped': props.stripedRows,
    'p-datatable-gridlines': props.showGridlines,
    'p-datatable-rtl': props.rtl,
    'p-datatable-responsive': props.responsive,
    [`p-datatable-${props.size}`]: props.size !== 'normal'
  }
])

const menu = ref()
const items = ref([
  {
    label: 'Export',
    items: [
      {
        label: 'PDF',
        icon: 'pi pi-file-pdf',
        command: () => exportToPDF()
      },
      {
        label: 'Excel',
        icon: 'pi pi-file-excel',
        command: () => exportToExcel()
      },
      // {
      //   label: 'CSV',
      //   icon: 'pi pi-download',
      //   command: () => exportToCSV()
      // }
    ]
  }
])
const toggle = (event: Event) => {
  menu.value.toggle(event)
}
//
// Helper function to get base64 image
const getBase64Image = async (imgPath: string): Promise<string> => {
  return new Promise((resolve) => {
    try {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onerror = () => {
        console.error('Error loading image:', imgPath);
        resolve('');
      };
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL('image/png'));
        } else {
          console.error('Could not get canvas context');
          resolve('');
        }
      };
      img.src = imgPath;
    } catch (error) {
      console.error('Error in getBase64Image:', error);
      resolve('');
    }
  });
};

const exportToPDF = async () => {
  try {
    // Dynamically import required libraries
    const { default: jsPDF } = await import('jspdf');
    const { default: autoTable } = await import('jspdf-autotable');

    // Get data from the table
    const rawData = props.value || [];

    if (rawData.length === 0) {
      console.warn('No data to export');
      return;
    }

    // Get column definitions
    // const columns = props.exportcolumns || [];
    const columns =props.transactionStatus==0?props.columns: props.exportcolumns || [];

    // Filter out Action and Status columns
    const filteredColumns = columns.filter(col => {
      const headerLower = col.header.toLowerCase();
      return !headerLower.includes('action') &&
             !headerLower.includes('status') &&
             !headerLower.includes('active') &&
             !headerLower.includes('inactive');
    });

    // Create PDF document
    const pdf = new jsPDF('l', 'mm', 'a4'); // landscape orientation for better table fit

    // Prepare headers and data for autotable
    const headers = filteredColumns.map(col => col.header);
    const data = rawData.map(row =>
      filteredColumns.map(col => String(row[col.field] || ''))
    );

    // Get logo as base64
    const logoPath = '/src/assets/Img/Logo/MoceroFooterLogo.png';
    const logoBase64 = await getBase64Image(logoPath);

    // Add logo and header information
    const title = 'Data Export';
    const headerInfo = {
      hospitalName: 'Mocero Hospital',
      contactInfo: '+91 1234567890',
      address: 'Mocero Hospital, 123 Main Street, City - 123456'
    };
    const footerInfo = {
      hospitalName: 'Mocero Hospital',
      contactInfo: '+91 1234567890'
    };

    const pageWidth = pdf.internal.pageSize.width;
    const headerY = 10;
    const headerLogoWidth = 45;
    const headerLogoHeight = 18;
    const headerPadding = 14;

    // Add logo to header
    if (logoBase64) {
      pdf.addImage(logoBase64, 'PNG', headerPadding, headerY, headerLogoWidth, headerLogoHeight);
    }

    // Add header with hospital info
    pdf.setFontSize(16);
    pdf.text(headerInfo.hospitalName, pageWidth/2, headerY + 8, { align: 'center' });
    pdf.setFontSize(10);
    pdf.text(headerInfo.address, pageWidth/2, headerY + 14, { align: 'center' });
    pdf.text(headerInfo.contactInfo, pageWidth/2, headerY + 20, { align: 'center' });

    // Add title
    pdf.setFontSize(14);
    pdf.text(title, pageWidth/2, headerY + 30, { align: 'center' });

    // Add table to PDF with adjusted margins to account for header
    autoTable(pdf, {
      head: [headers],
      body: data as any[][],
      theme: 'grid',
      headStyles: { fillColor: [66, 139, 202], textColor: 255 },
      margin: { top: 50 }, // Increased top margin to accommodate header and logo
      styles: { overflow: 'linebreak', cellWidth: 'auto' },
      columnStyles: { text: { cellWidth: 'auto' } },
      didDrawPage: (data) => {
        // Add footer on each page
        const pageSize = pdf.internal.pageSize;
        const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
        const footerY = pageHeight - 15;
        const footerLogoWidth = 35;
        const footerLogoHeight = 10;
        const footerPadding = 10;

        // Add line above footer
        pdf.setDrawColor(200, 200, 200);
        pdf.line(footerPadding, footerY, pageWidth - footerPadding, footerY);

        // Add logo to footer
        if (logoBase64) {
          pdf.addImage(logoBase64, 'PNG', (pageWidth - footerLogoWidth) / 2, footerY + 2, footerLogoWidth, footerLogoHeight);
        }

        pdf.setFontSize(9);
        pdf.text(footerInfo.hospitalName, footerPadding, footerY + 8);
        pdf.text(footerInfo.contactInfo, pageWidth - footerPadding, footerY + 8, { align: 'right' });

        // Add page number
        pdf.text(`Page ${data.pageNumber} of ${pdf.getNumberOfPages()}`,
                 pageWidth / 2,
                 pageHeight - 5,
                 { align: 'center' });
      }
    });

    // Save the PDF
    pdf.save('table-export.pdf');
  } catch (error) {
    console.error('Error exporting to PDF:', error);
  }
}

const exportToExcel = () => {
  try {
    // Get data from the table
    const rawData = props.value || [];

    if (rawData.length === 0) {
      console.warn('No data to export');
      return;
    }

    // Get column definitions
    const columns =props.transactionStatus==0?props.columns: props.exportcolumns || [];

    // Filter out Action and Status columns
    const filteredColumns = columns.filter(col => {
      const headerLower = col.header.toLowerCase();
      return !headerLower.includes('action') &&
             !headerLower.includes('status') &&
             !headerLower.includes('active') &&
             !headerLower.includes('inactive');
    });

    // Format data to match headers, excluding Action and Status fields
    const formattedData = rawData.map(row => {
      const formattedRow: Record<string, any> = {};
      filteredColumns.forEach(col => {
        // Use header as the key and field value as the value
        formattedRow[col.header] = row[col.field];
      });
      return formattedRow;
    });

    // Dynamically import xlsx
    import('xlsx').then((XLSX) => {
      // Create a worksheet
      const worksheet = XLSX.utils.json_to_sheet(formattedData);

      // Create a workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

      // Generate Excel file and trigger download
      XLSX.writeFile(workbook, 'table-export.xlsx');
    });
  } catch (error) {
    console.error('Error exporting to Excel:', error);
  }
}

const exportToCSV = () => {

}

</script>
